import compose from 'lodash/flowRight'
import * as React from 'react'
import {connect} from 'react-redux'

import Builds from '../components/common/Builds/Builds.container'
import type {BuildsOwnProps} from '../components/common/Builds/Builds.types'
import {usePage} from '../components/common/Pager/Pager.hooks'
import {withLocator} from '../contexts/locator'
import withHook from '../hocs/withHook'
import type {State} from '../reducers/types'
import {getBuildsLocatorWithPage, getBuildsReady, getSomeBuildsLoaded} from '../selectors'

type OwnProps = BuildsOwnProps & {
  locator: string | null | undefined
  page: number
}
type StateProps = {
  locatorWithPage: string | null | undefined
  ready: boolean
}
type Props = OwnProps & StateProps
type OwnState = {
  lastReadyLocator?: string | null
}

const mapStateToProps = (state: State, {locator, withPager, page}: OwnProps): StateProps => {
  const locatorWithPage =
    locator && (withPager ? getBuildsLocatorWithPage(state, locator, page) : locator)
  return {
    locatorWithPage,
    ready: getBuildsReady(state, locatorWithPage) || getSomeBuildsLoaded(state, locatorWithPage),
  }
}

class BuildsWithLastReadyLocator extends React.PureComponent<Props, OwnState> {
  static getDerivedStateFromProps(nextProps: Props, prevState: OwnState) {
    return {
      lastReadyLocator: nextProps.ready ? nextProps.locatorWithPage : prevState.lastReadyLocator,
    }
  }

  state = {
    lastReadyLocator: null,
  }

  render() {
    const {locator, ready, ...restProps} = this.props
    return <Builds {...restProps} lastReadyLocator={this.state.lastReadyLocator} />
  }
}

export default compose(
  withLocator,
  withHook(() => ({page: usePage()})),
  connect(mapStateToProps),
)(BuildsWithLastReadyLocator)
